<app-page-header-job [isCurveGray]="true" header="{{language.jobheader}}" backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<section class="section--feature">
    <div class="container">
        <div class="row radio--menu">
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <app-big-radio [active]="Personal" icon="assets/images/icon/user-job.png" title="{{language.jobtitleicon1}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Education" icon="assets/images/icon/mortarboard-job.png" title="{{language.jobtitleicon2}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Family" icon="assets/images/icon/family-room-job.png" title="{{language.jobtitleicon3}}"></app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio [active]="Experience" icon="assets/images/icon/suitcase-job.png" title="{{language.jobtitleicon4}}"></app-big-radio>
            </div>
        </div>
    </div>
</section>

<div ng-app="MyApp" ng-controller="MyController">

    <!-- ข้อมูลอื่นๆ -->
    <div class="container">
        <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 text-center card p-5 mt-5 mb-5">

                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{language.jobcomfirmdetail1}}</h2>
                </header>
                <!-- car -->
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="CAR" id="CAR1" value="true" (click)="handleChangeCar($event)">
                            <label class="form-check-label title-rd" for="CAR1">{{language.jobapplydetail58}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="CAR" id="CAR2" value="false" (click)="handleChangeCar($event)">
                            <label class="form-check-label title-rd" for="CAR2">{{language.jobapplydetail59}}</label>
                          </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobapplydetail41}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- motorcycle -->
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="MOTORCYCLE" id="MOTORCYCLE1" value="true" (click)="handleChangeMotorCycle($event)">
                            <label class="form-check-label title-rd" for="MOTORCYCLE1">{{language.jobapplydetail58}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="MOTORCYCLE" id="MOTORCYCLE2" value="false" (click)="handleChangeMotorCycle($event)">
                            <label class="form-check-label title-rd" for="MOTORCYCLE2">{{language.jobapplydetail59}}</label>
                          </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobapplydetail43}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- driver license -->
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3 no-padding">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="DRIVER_LICENSE1" (click)="handleChangeDriverLicense($event)">
                            <label class="form-check-label title-rd" for="DRIVER_LICENSE1">{{language.jobapplydetail47}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="DRIVER_LICENSE2" (click)="handleChangeDriverLicense($event)">
                            <label class="form-check-label title-rd" for="DRIVER_LICENSE2">{{language.jobapplydetail48}}</label>
                          </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobapplydetail46}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 1 -->
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_NOTPERFECT" id="FLAG_NOTPERFECT1" value="true" (click)="handleChangeNotPerfect($event)">
                            <label class="form-check-label title-rd" for="FLAG_NOTPERFECT1">{{language.jobapplydetail56}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_NOTPERFECT" id="FLAG_NOTPERFECT2" value="false" (click)="handleChangeNotPerfect($event)">
                            <label class="form-check-label title-rd" for="FLAG_NOTPERFECT2">{{language.jobapplydetail57}}</label>
                          </div>
                        <!-- <ul class="list-form list-unstyled row">
                            <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                              <label class="radio-inline icheck-label icheck[enqs9] needsclick">
                                <app-radio name="FLAG_NOTPERFECT" [checked]="flag_NotPerfect == true" [choiceValue]="true"
                                  (returnSelectValue)="handleChangeNotPerfect($event)"></app-radio>                                  
                                <span>{{language.jobapplydetail56}}</span>
                              </label>
                              <input class="radiobtn" type="radio" id="flag_NotPerfect" name="flag_NotPerfect" value="flag_NotPerfect" (click)="handleChangeNotPerfect($event)">
                            </li>
                            <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                              <label class="radio-inline icheck-label icheck[kssp1] needsclick">
                                <app-radio name="FLAG_NOTPERFECT" [checked]="flag_NotPerfect == false" [choiceValue]="false"
                                  (returnSelectValue)="handleChangeNotPerfect($event)"></app-radio> 
                                  <input class="radiobtn" type="radio" id="flag_NotPerfect" name="flag_NotPerfect" value="flag_NotPerfect" (click)="handleChangeNotPerfect($event)">
                                {{language.jobapplydetail57}}
                              </label>
                            </li>
                            </ul> -->
                        <!-- <input class="radiobtn" type="radio" id="flag_NotPerfect" name="flag_NotPerfect" value="flag_NotPerfect" (click)="handleChangeNotPerfect($event)"> -->
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobcomfirmdetail3}}
                            </div>
                            <!-- <div class="title l-height">
                                Have you ever been seriouly ill or lame or contracted with contagious disease?
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="theCheckbox1">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                        <div class="title">{{language.jobcomfirmdetail4}}</div>
                        <div class="input">
                            <div class="input--container">
                                <textarea (input)="NotPerfect_remark=$event.target.value" value="NotPerfect_remark" name="NotPerfect_remark" [(ngModel)]="NotPerfect_remark" maxlength="500" [ngClass]="{ 'is-invalid': Reqremark_NotPerfect }" required></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div *ngIf="Reqremark_NotPerfect" class="col-lg-6 col-md-6 col-sm-12 mb-3 error-message">
                        {{language.joberror1}}
                    </div>
                </div>

                <!-- 2 -->
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_ILLEGAL" id="FLAG_ILLEGAL1" value="true" (click)="handleChangeillegal($event)">
                            <label class="form-check-label title-rd" for="FLAG_ILLEGAL1">{{language.jobapplydetail56}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_ILLEGAL" id="FLAG_ILLEGAL2" value="false" (click)="handleChangeillegal($event)">
                            <label class="form-check-label title-rd" for="FLAG_ILLEGAL2">{{language.jobapplydetail57}}</label>
                          </div>
                    </div>
                    <!-- <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <input class="radiobtn" type="radio" id="flag_illegal" name="flag_illegal" value="flag_illegal" (click)="handleChangeillegal($event)">
                    </div> -->
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobcomfirmdetail5}}
                            </div>
                            <!-- <div class="title l-height">
                                Have you ever been arrested, investigated, sued or punished?
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="theCheckbox2">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                        <div class="title">{{language.jobcomfirmdetail4}}</div>
                        <div class="input">
                            <div class="input--container">
                                <textarea (input)="illegal_remark=$event.target.value" value="illegal_remark" name="illegal_remark" [(ngModel)]="illegal_remark" maxlength="500" [ngClass]="{ 'is-invalid': Reqremark_illegal }" required></textarea>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div *ngIf="Reqremark_illegal" class="col-lg-6 col-md-6 col-sm-12 mb-3 error-message">
                        {{language.joberror1}}
                    </div>
                </div>

                <!-- 3 -->
                <div class="row">
                    <!-- <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-5">
                        <input class="radiobtn" type="radio" id="flag_sack" name="flag_sack" value="flag_sack" (click)="handleChangesack($event)">
                    </div> -->
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_SACK" id="FLAG_SACK1" value="true" (click)="handleChangesack($event)">
                            <label class="form-check-label title-rd" for="FLAG_SACK1">{{language.jobapplydetail56}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_SACK" id="FLAG_SACK2" value="false" (click)="handleChangesack($event)">
                            <label class="form-check-label title-rd" for="FLAG_SACK2">{{language.jobapplydetail57}}</label>
                          </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobcomfirmdetail6}}
                            </div>
                            <!-- <div class="title l-height">
                                Have you ever been terminated or dismissed by mistakes?
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="theCheckbox3">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                        <div class="title">{{language.jobcomfirmdetail4}}</div>
                        <div class="input">
                            <div class="input--container">
                                <textarea (input)="sack_remark=$event.target.value" value="sack_remark" name="sack_remark" [(ngModel)]="sack_remark" maxlength="500" [ngClass]="{ 'is-invalid': Reqremark_sack }" required></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div *ngIf="Reqremark_sack" class="col-lg-6 col-md-6 col-sm-12 mb-3 error-message">
                        {{language.joberror1}}
                    </div>
                </div>

                <!-- 4 -->
                <div class="row">                   
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_WORKWITHASSET" id="FLAG_WORKWITHASSET1" value="true" (click)="handleChangeWorkWithAsset($event)">
                            <label class="form-check-label title-rd" for="FLAG_WORKWITHASSET1">{{language.jobapplydetail56}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="FLAG_WORKWITHASSET" id="FLAG_WORKWITHASSET2" value="false" (click)="handleChangeWorkWithAsset($event)">
                            <label class="form-check-label title-rd" for="FLAG_WORKWITHASSET2">{{language.jobapplydetail57}}</label>
                          </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobcomfirmdetail7}}
                            </div>
                            <!-- <div class="title l-height">
                                Have you ever been employed by One Asset Management Limited?
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="theCheckbox4">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                        <div class="title">{{language.jobcomfirmdetail4}}</div>
                        <div class="input">
                            <div class="input--container">
                                <textarea (input)="WorkWithAsset_reamrk=$event.target.value" value="WorkWithAsset_reamrk" name="WorkWithAsset_reamrk" [(ngModel)]="WorkWithAsset_reamrk" maxlength="500" [ngClass]="{ 'is-invalid': Reqremark_WorkWithAsset }" required></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div *ngIf="Reqremark_WorkWithAsset" class="col-lg-6 col-md-6 col-sm-12 mb-3 error-message">
                        {{language.joberror1}}
                    </div>
                </div>

                <!-- How do u know? -->
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-3 mt-3">
                        <div class="form--item">
                            <div class="title">
                                {{language.jobapplydetail49}}
                            </div>
                            <!-- <div class="title l-height">
                                Have you ever been terminated or dismissed by mistakes?
                            </div> -->
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12 mb-3 mt-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="EMPLOYMENT" id="EMPLOYMENT1" value="ONEAM" (click)="handleChangeEmployment($event)">
                            <label class="form-check-label title-rd" for="EMPLOYMENT1">{{language.jobapplydetail50}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="EMPLOYMENT" id="EMPLOYMENT2" value="AGENT"  (click)="handleChangeEmployment($event)">
                            <label class="form-check-label title-rd" for="EMPLOYMENT2">{{language.jobapplydetail51}}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="EMPLOYMENT" id="EMPLOYMENT3" value="EMPLOYEE"  (click)="handleChangeEmployment($event)">
                            <label class="form-check-label title-rd" for="EMPLOYMENT3">{{language.jobapplydetail52}}</label>
                          </div>
                    </div>
                    
                </div>

                <div class="row" *ngIf="theEmployeeShow">
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12 mb-3">
                        <div class="title">{{language.jobapplydetail53}}</div>
                        <div class="input">
                            <div class="input--container">
                                <input (input)="employee=$event.target.value" [(ngModel)]="employee" type="text" class="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3">
                    </div>
                    <div *ngIf="Reqremark_sack" class="col-lg-6 col-md-6 col-sm-12 mb-3 error-message">
                        {{language.joberror1}}
                    </div>
                </div>

                <header class="heading-contact mb-5 mt-5">
                    <h2 class="topic-title">{{language.jobapplydetail24}}</h2>
                    <p class="ingnor-top">* {{language.jobeduwarning2}} -</p>
                </header>

                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <div class="form--item">
                            <div class="title">{{language.jobcomfirmdetail8}}
                            </div>
                            <!-- <div class="title l-height">List person of 2 references who knows you well.</div> -->
                        </div>
                    </div>
                </div>

                <form [formGroup]="formDataRef">
                    <div formArrayName="RefInfo" *ngFor="let Data of  formDataRef.get('RefInfo')['controls']; let i = index">
                        <ng-container [formGroupName]="i">
                            <div inline>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-4 mt-5">
                                        <div class="title">{{language.jobcomfirmdetail2}} {{i+1}}</div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                                        <app-button-delete-job text="{{language.jobbtn2}}" (click)="removeLicense(i)">
                                            <button class="btn btn-danger mr-auto">
                        <span>
                          <a routerLink="">{{language.jobbtn2}}</a>
                        </span>
                      </button>
                                        </app-button-delete-job>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-2 col-md-2 col-sm-2 mb-3">

                                        <div class="form--item">
                                            <div class="title">{{language.jobfamtitle1}}</div>
                                            <div class="form-group">
                                                <div class="dropdown">
                                                    <select formControlName="ref_title" class="form-control" [ngClass]="{ 'is-invalid': Reqref_title }">
                            <option *ngFor="let items of Title" [value]="items" style=" border-radius: 50px;">
                              {{ items }}</option>
                          </select>
                                                    <div *ngIf="Reqref_title" class="error-message">
                                                        {{language.joberror1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title">{{language.jobfamtitle10}}</div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input formControlName="ref_fname" type="text" class="form-control" [ngClass]="{ 'is-invalid': Reqref_fname }" />
                                                </div>
                                                <div *ngIf="Reqref_fname" class="error-message">
                                                    {{language.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title">{{language.jobfamtitle11}}</div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input formControlName="ref_lname" type="text" class="form-control" [ngClass]="{ 'is-invalid': Reqref_lname }" />
                                                </div>
                                                <div *ngIf="Reqref_lname" class="error-message">
                                                    {{language.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-2 col-md-2 col-sm-2 mb-3">
                                        <div class="form--item">
                                            <div class="title">{{language.jobapplydetail23}}</div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input formControlName="ref_position" type="text" class="form-control" [ngClass]="{ 'is-invalid': Reqref_position }" />
                                                </div>
                                                <div *ngIf="Reqref_position" class="error-message">
                                                    {{language.joberror1}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title">{{language.jobfamtitle5}}</div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input formControlName="ref_tel" type="text" class="form-control" [ngClass]="{ 'is-invalid': Reqref_tel }" numbersOnly [maxLength]="10" />
                                                </div>
                                                <div *ngIf="Reqref_tel" class="error-message">
                                                    {{language.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 mb-3">
                                        <div class="form--item">
                                            <div class="title">{{language.jobapplydetail25}}</div>
                                            <div class="input">
                                                <div class="input--container">
                                                    <input formControlName="ref_relation" type="text" class="form-control" [ngClass]="{ 'is-invalid': Reqref_relation }" />
                                                </div>
                                                <div *ngIf="Reqref_relation" class="error-message">
                                                    {{language.joberror1}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </form>

                <div class="row" *ngIf="clickCount != 2">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <app-button-job text="{{language.jobbtn1}}" (click)="addLicense()">
                            <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn1}}</a>
                </span>
              </button>
                        </app-button-job>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                      <div class="title d-flex">{{language.jobapplydetail54}} 
                      </div>
                      <div class="input--container">
                        <textarea type="text" class="form-control"
                        (input)="aboutYourself=$event.target.value" [(ngModel)]="aboutYourself" maxlength="300"></textarea>
                      </div>
                    </div>
                  </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-5">
                        <input type="checkbox" class="checkbox" id="flag_confirm" value="flag_confirm" [(ngModel)]="flag_confirm" (change)="handleChangeflag($event)" [ngClass]="{ 'is-invalid': Reqflag_confirm }">
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3">
                        <div class="form--item">
                            <div class=" title">
                                <p class="red l-height">{{language.jobcomfirmdetail9}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <div class="topic-title">
                            <p class="red l-height">{{language.jobcomfirmdetail11}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class=" title">
                            <p class="red l-height">{{language.jobcomfirmdetail12}}</p>
                        </div>
                    </div>
                </div>                
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class=" title">
                            <p class="red l-height">{{language.jobcomfirmdetail14}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-12 mb-3 mt-5">
                        <input type="checkbox" class="checkbox" id="flag_pdpa" value="flag_pdpa" [(ngModel)]="flag_pdpa">
                    </div>                    
                    <div class="col-lg-10 col-md-10 col-sm-12 mb-3">
                        <div class="form--item">
                            <div class=" title">
                                <p class="red l-height">{{language.jobcomfirmdetail13}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class=" title">
                            <p class="red l-height"><U>{{language.jobcomfirmdetail16}}</U>  {{language.jobcomfirmdetail15}} <a [href]="language.jobcomfirmdetail15_2">{{language.jobcomfirmdetail15_2}}</a> {{language.jobcomfirmdetail15_3}}</p>
                        </div>
                    </div>
                </div>
                <!-- ถัดไป -->
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                        <app-button text="{{language.jobbtn6}}" (click)="goExperience()">
                            <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn6}}</a>
                </span>
              </button>
                        </app-button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                        <app-button [ngClass]="{'disabled': flag_confirm !== true}" text="{{language.jobbtn7}}" (click)="submit()">
                            <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn7}}</a>
                </span>
              </button>
                        </app-button>
                    </div>
                </div>
                <!-- ถัดไป -->
            </div>
        </div>
    </div>
    <!-- ข้อมูลอื่นๆ -->
</div>